export default "__VITE_ASSET__sp$xxVx3__"